module.exports = __webpack_public_path__ + "static/media/step-5.7e4c6e09.png";